import React, { useRef, useMemo } from 'react';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';

import styles from './index.pcss';
import { fetchProducts } from '../../../../../actions/shared/productsData';
import { getLuxeFlags } from '../../../../../Flags/selectors';
import { getCurrentStore } from '../../../../selectors/metaData';
import { fireFilterApplied, fireFilterRemoved } from '../../analytics';
import {
  stringifyFacets,
  parseProductQueryString,
  buildQueryString
} from '../../../../../utils/products';

const cx = classNames.bind(styles);

const CategoryFilters = props => {
  const {
    currentStore = '',
    freeTextSearch = '',
    facets,
    request = {},
    luxeFlags = {},
    fetchProducts = () => {},
    compoundFilterNames = {}
  } = props;
  const { query: requestQuery = {} } = request as any;
  const search_term: string = requestQuery.text || freeTextSearch || '';

  const { visualFiltersState = '', visualFilters = [] } = facets;

  const { isThemeEnable } = luxeFlags;
  const luxe = isThemeEnable === 'ON' && currentStore === 'luxe';
  const fleek = String(currentStore).toLowerCase() === 'ajiogram';

  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const sortedFilters = useMemo(() => {
    return [...visualFilters].sort((a, b) => {
      const aSelected = visualFiltersState.includes(`${a.defaultDisplayName}:T`);
      const bSelected = visualFiltersState.includes(`${b.defaultDisplayName}:T`);
      if (aSelected === bSelected) return 0;
      return aSelected ? -1 : 1;
    });
  }, [visualFilters, visualFiltersState]);

  const filterClickHandler = (filterName: string) => {
    const { query = {} } = request;
    const { currentFacets: currentFacetsData = {} } = facets;
    const { entities = {} } = currentFacetsData;

    const isRemoving = visualFiltersState.includes(`${filterName}:T`);
    const newVisualFiltersState = isRemoving
      ? visualFiltersState.replace(`${filterName}:T`, `${filterName}:FC`)
      : visualFiltersState.replace(`${filterName}:F`, `${filterName}:TC`);

    const filterObj = sortedFilters.find(f => f.defaultDisplayName === filterName);
    const position = sortedFilters.findIndex(f => f.defaultDisplayName === filterName) + 1;
    const filterEntry = {
      section: 1,
      position,
      facet_key: filterName,
      facet_value: filterName,
      value: filterName,
      filterid: filterObj?.filterId || ''
    };

    if (isRemoving) {
      fireFilterRemoved('visual', [filterEntry], {
        screen_title: freeTextSearch,
        search_term,
        raw_query: search_term || ''
      });
    } else {
      fireFilterApplied('visual', [filterEntry], {
        screen_title: freeTextSearch,
        search_term,
        raw_query: search_term || ''
      });
    }

    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollLeft = 0;
    }

    const entityFacets: Record<string, string[]> = {};
    Object.keys(entities).forEach(entityId => {
      const entity = entities[entityId];
      if (!entity?.childrens?.length || !entity.code) return;
      entity.childrens.forEach((childId: string) => {
        const child = entities[childId];
        if (child?.selected && child?.code) {
          if (!entityFacets[entity.code]) entityFacets[entity.code] = [];
          if (!entityFacets[entity.code].includes(child.code)) {
            entityFacets[entity.code].push(child.code);
          }
        }
      });
    });

    const parsed: any = parseProductQueryString(query.query || '');
    const newQueryStr = buildQueryString(['sortBy', 'facets'], {
      sortBy: parsed.sortBy,
      facets: stringifyFacets(entityFacets)
    });

    fetchProducts({
      request: {
        ...request,
        currentPage: 0,
        query: {
          ...query,
          currentPage: 0,
          visualFiltersState: newVisualFiltersState,
          query: newQueryStr
        }
      },
      isVisualFilterInteraction: true
    });
  };

  return (
    <div ref={scrollContainerRef} className={cx('category-filters')}>
      {sortedFilters.map(filter => {
        const isDisabled = visualFiltersState.includes(`${filter.defaultDisplayName}:D`);
        return (
        <div
          key={filter.filterId}
          className={cx('category-filter', {
            selected: visualFiltersState.includes(`${filter.defaultDisplayName}:T`),
            disabled: isDisabled,
            luxe,
            ajiogram: fleek
          })}
          onClick={() => !isDisabled && filterClickHandler(filter.defaultDisplayName)}
        >
          <img
            className={cx({ ajiogram: fleek })}
            src={filter.imageUrl}
            alt={filter.defaultDisplayName}
          />
          <p className={cx({ ajiogram: fleek })}>{compoundFilterNames?.[filter?.defaultDisplayName] || filter.defaultDisplayName}</p>
        </div>
        );
      })}
    </div>
  );
};

function mapStateToProps(state, ownProps) {
  const { facets = {}, request = {} } = state;

  return {
    facets,
    request,
    luxeFlags: getLuxeFlags(state?.flags),
    currentStore: getCurrentStore(state),
    freeTextSearch: state?.productsAdditionalInfo?.freeTextSearch
  };
}

const mapDispatchToProps = dispatch => {
  return {
    fetchProducts: params =>
      dispatch(
        fetchProducts({
          request: params.request,
          fetchFacetsOnly: params.fetchFacetsOnly,
          isRequestOrginIsBrowser: true,
          isVisualFilterInteraction: params.isVisualFilterInteraction || false
        })
      )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CategoryFilters);
